<template lang="pug">
  div(:data-test-id="ContentCategorySelectionAutomatedTestIds.INPUT_CONTENT_CATEGORY")
    Category(
      v-model="lazyCategories"
      :rules="categoryRules"
      :content-type="contentType"
      :disabled="disabled"
      :close-on-select="closeOnSelect"
    )
</template>

<script>
import { useTwoWayAutoBinding } from '@/helpers/misc/binding';
import Category from './Category.vue';
import ContentCategorySelectionAutomatedTestIds from './constants';

export default {
  name: 'CategorySelectionComposite',
  components: {
    Category,
  },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    categoryRules: {
      type: String,
      default: '',
    },
    contentType: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { lazyValue: lazyCategories } = useTwoWayAutoBinding('categories', emit, props);

    return {
      lazyCategories,
      ContentCategorySelectionAutomatedTestIds,
    };
  },
};
</script>
